// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file client/copy_trading.proto (package client, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../buf/validate/validate_pb";
import type { TradingProfileAnalyticsMessageSchema, TradingProfilePeriodPreset } from "./trading_pb";
import { file_client_trading } from "./trading_pb";
import type { Pagination } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file client/copy_trading.proto.
 */
export const file_client_copy_trading: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_client_trading, file_common_common, file_google_protobuf_empty]);

/**
 * @generated from message client.LeaderProfileMessage
 */
export type LeaderProfileMessage = Message<"client.LeaderProfileMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string nickname = 2;
   */
  nickname?: string;

  /**
   * @generated from field: optional string avatar_url = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: string aum = 4;
   */
  aum: string;

  /**
   * @generated from field: int32 followers_count = 5;
   */
  followersCount: number;

  /**
   * @generated from field: client.LeaderSettingsMessage settings = 6;
   */
  settings?: LeaderSettingsMessage;

  /**
   * @generated from field: client.LeaderStatsMessage stats = 7;
   */
  stats?: LeaderStatsMessage;

  /**
   * @generated from field: repeated string follower_avatars = 8;
   */
  followerAvatars: string[];
};

/**
 * Describes the message client.LeaderProfileMessage.
 * Use `create(LeaderProfileMessageSchema)` to create a new message.
 */
export const LeaderProfileMessageSchema: GenMessage<LeaderProfileMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 0);

/**
 * @generated from message client.LeaderSettingsMessage
 */
export type LeaderSettingsMessage = Message<"client.LeaderSettingsMessage"> & {
  /**
   * @generated from field: bool followers_limit_enabled = 1;
   */
  followersLimitEnabled: boolean;

  /**
   * @generated from field: optional int32 max_followers = 2;
   */
  maxFollowers?: number;
};

/**
 * Describes the message client.LeaderSettingsMessage.
 * Use `create(LeaderSettingsMessageSchema)` to create a new message.
 */
export const LeaderSettingsMessageSchema: GenMessage<LeaderSettingsMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 1);

/**
 * @generated from message client.LeaderStatsMessage
 */
export type LeaderStatsMessage = Message<"client.LeaderStatsMessage"> & {
  /**
   * Core trading stats (mirrors TradingProfileKpiMessage)
   *
   * @generated from field: int32 trades = 1;
   */
  trades: number;

  /**
   * @generated from field: string profit = 2;
   */
  profit: string;

  /**
   * @generated from field: string win_rate = 3;
   */
  winRate: string;

  /**
   * @generated from field: string trading_volume = 4;
   */
  tradingVolume: string;

  /**
   * @generated from field: int32 current_streak = 5;
   */
  currentStreak: number;

  /**
   * @generated from field: int32 best_streak = 6;
   */
  bestStreak: number;

  /**
   * Additional copy trading metrics
   *
   * @generated from field: int32 call_trades_count = 7;
   */
  callTradesCount: number;

  /**
   * @generated from field: int32 put_trades_count = 8;
   */
  putTradesCount: number;

  /**
   * Activity: last N days with at least one trade
   *
   * @generated from field: int32 active_days_last_30 = 9;
   */
  activeDaysLast30: number;

  /**
   * Activity heatmap: last 365 days (date YYYY-MM-DD, count = trades that day)
   *
   * @generated from field: repeated client.DayActivityMessage activity_heatmap = 10;
   */
  activityHeatmap: DayActivityMessage[];
};

/**
 * Describes the message client.LeaderStatsMessage.
 * Use `create(LeaderStatsMessageSchema)` to create a new message.
 */
export const LeaderStatsMessageSchema: GenMessage<LeaderStatsMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 2);

/**
 * @generated from message client.DayActivityMessage
 */
export type DayActivityMessage = Message<"client.DayActivityMessage"> & {
  /**
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message client.DayActivityMessage.
 * Use `create(DayActivityMessageSchema)` to create a new message.
 */
export const DayActivityMessageSchema: GenMessage<DayActivityMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 3);

/**
 * @generated from message client.GetMyFollowersResponse
 */
export type GetMyFollowersResponse = Message<"client.GetMyFollowersResponse"> & {
  /**
   * @generated from field: client.FollowersSummaryMessage summary = 1;
   */
  summary?: FollowersSummaryMessage;

  /**
   * @generated from field: repeated client.FollowerRowMessage followers = 2;
   */
  followers: FollowerRowMessage[];

  /**
   * @generated from field: common.Pagination pagination = 3;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.GetMyFollowersResponse.
 * Use `create(GetMyFollowersResponseSchema)` to create a new message.
 */
export const GetMyFollowersResponseSchema: GenMessage<GetMyFollowersResponse> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 4);

/**
 * @generated from message client.FollowersSummaryMessage
 */
export type FollowersSummaryMessage = Message<"client.FollowersSummaryMessage"> & {
  /**
   * @generated from field: int32 total_followers = 1;
   */
  totalFollowers: number;

  /**
   * @generated from field: int32 active_followers = 2;
   */
  activeFollowers: number;

  /**
   * @generated from field: int32 stopped_followers = 3;
   */
  stoppedFollowers: number;

  /**
   * @generated from field: string total_followers_balance = 4;
   */
  totalFollowersBalance: string;

  /**
   * @generated from field: string total_followers_trading_volume = 5;
   */
  totalFollowersTradingVolume: string;

  /**
   * @generated from field: string total_followers_pnl = 6;
   */
  totalFollowersPnl: string;
};

/**
 * Describes the message client.FollowersSummaryMessage.
 * Use `create(FollowersSummaryMessageSchema)` to create a new message.
 */
export const FollowersSummaryMessageSchema: GenMessage<FollowersSummaryMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 5);

/**
 * @generated from message client.FollowerRowMessage
 */
export type FollowerRowMessage = Message<"client.FollowerRowMessage"> & {
  /**
   * @generated from field: string follower_id = 1;
   */
  followerId: string;

  /**
   * @generated from field: optional string nickname = 2;
   */
  nickname?: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 4;
   */
  lastName?: string;

  /**
   * @generated from field: optional string email_masked = 5;
   */
  emailMasked?: string;

  /**
   * @generated from field: client.CopyTradingSubscriptionStatus status = 6;
   */
  status: CopyTradingSubscriptionStatus;

  /**
   * @generated from field: string copy_percentage = 7;
   */
  copyPercentage: string;

  /**
   * @generated from field: string stop_balance = 8;
   */
  stopBalance: string;

  /**
   * @generated from field: string min_trade_amount = 9;
   */
  minTradeAmount: string;

  /**
   * @generated from field: optional string max_trade_amount = 10;
   */
  maxTradeAmount?: string;

  /**
   * @generated from field: string current_balance = 11;
   */
  currentBalance: string;

  /**
   * @generated from field: string copy_trading_pnl = 12;
   */
  copyTradingPnl: string;

  /**
   * @generated from field: int32 trades_count = 13;
   */
  tradesCount: number;

  /**
   * @generated from field: string trading_volume = 14;
   */
  tradingVolume: string;

  /**
   * @generated from field: string started_at = 15;
   */
  startedAt: string;

  /**
   * @generated from field: optional string last_copied_trade_at = 16;
   */
  lastCopiedTradeAt?: string;

  /**
   * @generated from field: optional string stopped_at = 17;
   */
  stoppedAt?: string;

  /**
   * @generated from field: optional string stop_reason = 18;
   */
  stopReason?: string;
};

/**
 * Describes the message client.FollowerRowMessage.
 * Use `create(FollowerRowMessageSchema)` to create a new message.
 */
export const FollowerRowMessageSchema: GenMessage<FollowerRowMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 6);

/**
 * @generated from message client.GetLeaderTradesRequest
 */
export type GetLeaderTradesRequest = Message<"client.GetLeaderTradesRequest"> & {
  /**
   * @generated from field: optional common.Pagination pagination = 1;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.GetLeaderTradesRequest.
 * Use `create(GetLeaderTradesRequestSchema)` to create a new message.
 */
export const GetLeaderTradesRequestSchema: GenMessage<GetLeaderTradesRequest> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 7);

/**
 * @generated from message client.GetLeaderTradesResponse
 */
export type GetLeaderTradesResponse = Message<"client.GetLeaderTradesResponse"> & {
  /**
   * @generated from field: repeated client.LeaderTradeRowMessage data = 1;
   */
  data: LeaderTradeRowMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.GetLeaderTradesResponse.
 * Use `create(GetLeaderTradesResponseSchema)` to create a new message.
 */
export const GetLeaderTradesResponseSchema: GenMessage<GetLeaderTradesResponse> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 8);

/**
 * @generated from message client.LeaderTradeRowMessage
 */
export type LeaderTradeRowMessage = Message<"client.LeaderTradeRowMessage"> & {
  /**
   * @generated from field: string bet_id = 1;
   */
  betId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: string amount = 3;
   */
  amount: string;

  /**
   * @generated from field: string bet_type = 4;
   */
  betType: string;

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt: string;

  /**
   * @generated from field: optional string settled_at = 6;
   */
  settledAt?: string;

  /**
   * @generated from field: optional string outcome = 7;
   */
  outcome?: string;

  /**
   * @generated from field: optional string profit_loss = 8;
   */
  profitLoss?: string;

  /**
   * @generated from field: int32 copied_followers_count = 9;
   */
  copiedFollowersCount: number;

  /**
   * @generated from field: optional string entry_price = 10;
   */
  entryPrice?: string;

  /**
   * @generated from field: optional string close_price = 11;
   */
  closePrice?: string;
};

/**
 * Describes the message client.LeaderTradeRowMessage.
 * Use `create(LeaderTradeRowMessageSchema)` to create a new message.
 */
export const LeaderTradeRowMessageSchema: GenMessage<LeaderTradeRowMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 9);

/**
 * @generated from message client.CopyTradingSubscriptionMessage
 */
export type CopyTradingSubscriptionMessage = Message<"client.CopyTradingSubscriptionMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string lead_trader_id = 2;
   */
  leadTraderId: string;

  /**
   * @generated from field: optional string lead_trader_nickname = 3;
   */
  leadTraderNickname?: string;

  /**
   * @generated from field: optional string lead_trader_avatar_url = 4;
   */
  leadTraderAvatarUrl?: string;

  /**
   * @generated from field: client.CopyTradingSubscriptionStatus status = 5;
   */
  status: CopyTradingSubscriptionStatus;

  /**
   * @generated from field: string copy_percentage = 6;
   */
  copyPercentage: string;

  /**
   * @generated from field: string stop_balance = 7;
   */
  stopBalance: string;

  /**
   * @generated from field: string min_trade_amount = 8;
   */
  minTradeAmount: string;

  /**
   * @generated from field: optional string max_trade_amount = 9;
   */
  maxTradeAmount?: string;

  /**
   * @generated from field: string started_at = 10;
   */
  startedAt: string;

  /**
   * @generated from field: optional string stopped_at = 11;
   */
  stoppedAt?: string;

  /**
   * @generated from field: optional string stop_reason = 12;
   */
  stopReason?: string;

  /**
   * @generated from field: optional string last_copied_trade_at = 13;
   */
  lastCopiedTradeAt?: string;

  /**
   * @generated from field: int32 trades_count = 14;
   */
  tradesCount: number;

  /**
   * @generated from field: string trading_volume = 15;
   */
  tradingVolume: string;

  /**
   * @generated from field: string copy_trading_pnl = 16;
   */
  copyTradingPnl: string;
};

/**
 * Describes the message client.CopyTradingSubscriptionMessage.
 * Use `create(CopyTradingSubscriptionMessageSchema)` to create a new message.
 */
export const CopyTradingSubscriptionMessageSchema: GenMessage<CopyTradingSubscriptionMessage> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 10);

/**
 * @generated from message client.GetMySubscriptionResponse
 */
export type GetMySubscriptionResponse = Message<"client.GetMySubscriptionResponse"> & {
  /**
   * @generated from field: optional client.CopyTradingSubscriptionMessage subscription = 1;
   */
  subscription?: CopyTradingSubscriptionMessage;
};

/**
 * Describes the message client.GetMySubscriptionResponse.
 * Use `create(GetMySubscriptionResponseSchema)` to create a new message.
 */
export const GetMySubscriptionResponseSchema: GenMessage<GetMySubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 11);

/**
 * @generated from message client.UpdateLeaderSettingsRequest
 */
export type UpdateLeaderSettingsRequest = Message<"client.UpdateLeaderSettingsRequest"> & {
  /**
   * @generated from field: bool followers_limit_enabled = 1;
   */
  followersLimitEnabled: boolean;

  /**
   * @generated from field: optional int32 max_followers = 2;
   */
  maxFollowers?: number;
};

/**
 * Describes the message client.UpdateLeaderSettingsRequest.
 * Use `create(UpdateLeaderSettingsRequestSchema)` to create a new message.
 */
export const UpdateLeaderSettingsRequestSchema: GenMessage<UpdateLeaderSettingsRequest> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 12);

/**
 * @generated from message client.GetLeaderAnalyticsRequest
 */
export type GetLeaderAnalyticsRequest = Message<"client.GetLeaderAnalyticsRequest"> & {
  /**
   * @generated from field: string leader_id = 1;
   */
  leaderId: string;

  /**
   * @generated from field: client.TradingProfilePeriodPreset period_preset = 2;
   */
  periodPreset: TradingProfilePeriodPreset;

  /**
   * @generated from field: optional string date_from = 3;
   */
  dateFrom?: string;

  /**
   * @generated from field: optional string date_to = 4;
   */
  dateTo?: string;

  /**
   * @generated from field: optional string time_zone = 5;
   */
  timeZone?: string;
};

/**
 * Describes the message client.GetLeaderAnalyticsRequest.
 * Use `create(GetLeaderAnalyticsRequestSchema)` to create a new message.
 */
export const GetLeaderAnalyticsRequestSchema: GenMessage<GetLeaderAnalyticsRequest> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 13);

/**
 * @generated from message client.GetLeaderProfileRequest
 */
export type GetLeaderProfileRequest = Message<"client.GetLeaderProfileRequest"> & {
  /**
   * @generated from field: string leader_id = 1;
   */
  leaderId: string;
};

/**
 * Describes the message client.GetLeaderProfileRequest.
 * Use `create(GetLeaderProfileRequestSchema)` to create a new message.
 */
export const GetLeaderProfileRequestSchema: GenMessage<GetLeaderProfileRequest> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 14);

/**
 * @generated from message client.SubscribeRequest
 */
export type SubscribeRequest = Message<"client.SubscribeRequest"> & {
  /**
   * @generated from field: string leader_id = 1;
   */
  leaderId: string;

  /**
   * @generated from field: string copy_percentage = 2;
   */
  copyPercentage: string;

  /**
   * @generated from field: string stop_balance = 3;
   */
  stopBalance: string;

  /**
   * @generated from field: string min_trade_amount = 4;
   */
  minTradeAmount: string;

  /**
   * @generated from field: optional string max_trade_amount = 5;
   */
  maxTradeAmount?: string;
};

/**
 * Describes the message client.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 15);

/**
 * @generated from message client.UnsubscribeRequest
 */
export type UnsubscribeRequest = Message<"client.UnsubscribeRequest"> & {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;
};

/**
 * Describes the message client.UnsubscribeRequest.
 * Use `create(UnsubscribeRequestSchema)` to create a new message.
 */
export const UnsubscribeRequestSchema: GenMessage<UnsubscribeRequest> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 16);

/**
 * @generated from message client.UpdateSubscriptionSettingsRequest
 */
export type UpdateSubscriptionSettingsRequest = Message<"client.UpdateSubscriptionSettingsRequest"> & {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * @generated from field: string copy_percentage = 2;
   */
  copyPercentage: string;

  /**
   * @generated from field: string stop_balance = 3;
   */
  stopBalance: string;

  /**
   * @generated from field: string min_trade_amount = 4;
   */
  minTradeAmount: string;

  /**
   * @generated from field: optional string max_trade_amount = 5;
   */
  maxTradeAmount?: string;
};

/**
 * Describes the message client.UpdateSubscriptionSettingsRequest.
 * Use `create(UpdateSubscriptionSettingsRequestSchema)` to create a new message.
 */
export const UpdateSubscriptionSettingsRequestSchema: GenMessage<UpdateSubscriptionSettingsRequest> = /*@__PURE__*/
  messageDesc(file_client_copy_trading, 17);

/**
 * @generated from enum client.CopyTradingSubscriptionStatus
 */
export enum CopyTradingSubscriptionStatus {
  /**
   * @generated from enum value: COPY_TRADING_SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COPY_TRADING_SUBSCRIPTION_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: COPY_TRADING_SUBSCRIPTION_STATUS_STOPPED_BY_USER = 2;
   */
  STOPPED_BY_USER = 2,

  /**
   * @generated from enum value: COPY_TRADING_SUBSCRIPTION_STATUS_STOPPED_BY_BALANCE = 3;
   */
  STOPPED_BY_BALANCE = 3,

  /**
   * @generated from enum value: COPY_TRADING_SUBSCRIPTION_STATUS_TRADER_DISABLED = 4;
   */
  TRADER_DISABLED = 4,

  /**
   * @generated from enum value: COPY_TRADING_SUBSCRIPTION_STATUS_TRADER_BLOCKED = 5;
   */
  TRADER_BLOCKED = 5,

  /**
   * @generated from enum value: COPY_TRADING_SUBSCRIPTION_STATUS_ADMIN_STOPPED = 6;
   */
  ADMIN_STOPPED = 6,
}

/**
 * Describes the enum client.CopyTradingSubscriptionStatus.
 */
export const CopyTradingSubscriptionStatusSchema: GenEnum<CopyTradingSubscriptionStatus> = /*@__PURE__*/
  enumDesc(file_client_copy_trading, 0);

/**
 * @generated from service client.CopyTradingRPCService
 */
export const CopyTradingRPCService: GenService<{
  /**
   * Lead trader — own profile and management
   *
   * @generated from rpc client.CopyTradingRPCService.GetMyLeaderProfile
   */
  getMyLeaderProfile: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof LeaderProfileMessageSchema;
  },
  /**
   * @generated from rpc client.CopyTradingRPCService.UpdateLeaderSettings
   */
  updateLeaderSettings: {
    methodKind: "unary";
    input: typeof UpdateLeaderSettingsRequestSchema;
    output: typeof LeaderSettingsMessageSchema;
  },
  /**
   * @generated from rpc client.CopyTradingRPCService.GetMyFollowers
   */
  getMyFollowers: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetMyFollowersResponseSchema;
  },
  /**
   * @generated from rpc client.CopyTradingRPCService.GetLeaderTrades
   */
  getLeaderTrades: {
    methodKind: "unary";
    input: typeof GetLeaderTradesRequestSchema;
    output: typeof GetLeaderTradesResponseSchema;
  },
  /**
   * Analytics for a leader profile (period-aware KPI + charts)
   *
   * @generated from rpc client.CopyTradingRPCService.GetLeaderAnalytics
   */
  getLeaderAnalytics: {
    methodKind: "unary";
    input: typeof GetLeaderAnalyticsRequestSchema;
    output: typeof TradingProfileAnalyticsMessageSchema;
  },
  /**
   * Follower — search and subscription
   *
   * @generated from rpc client.CopyTradingRPCService.GetLeaderProfile
   */
  getLeaderProfile: {
    methodKind: "unary";
    input: typeof GetLeaderProfileRequestSchema;
    output: typeof LeaderProfileMessageSchema;
  },
  /**
   * @generated from rpc client.CopyTradingRPCService.Subscribe
   */
  subscribe: {
    methodKind: "unary";
    input: typeof SubscribeRequestSchema;
    output: typeof CopyTradingSubscriptionMessageSchema;
  },
  /**
   * @generated from rpc client.CopyTradingRPCService.Unsubscribe
   */
  unsubscribe: {
    methodKind: "unary";
    input: typeof UnsubscribeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc client.CopyTradingRPCService.UpdateSubscriptionSettings
   */
  updateSubscriptionSettings: {
    methodKind: "unary";
    input: typeof UpdateSubscriptionSettingsRequestSchema;
    output: typeof CopyTradingSubscriptionMessageSchema;
  },
  /**
   * @generated from rpc client.CopyTradingRPCService.GetMySubscription
   */
  getMySubscription: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetMySubscriptionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_client_copy_trading, 0);

